export enum Errors {
  VALIDATION = 'Error',
  ERROR = 'Error',
  UNAUTHORIZED = 'Error',
  CONNECTION_ERROR = 'Error',
}
